<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row align="center" class="produto-selector-root">
      <v-card class="produto-selector-card">
        <v-row>
          <v-col cols="12" md="6"
            ><v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
          </v-col>
        </v-row>
        <v-row class="produto-selector-grid">
          <v-col cols="12" md="8" class="produto-selector-col produto-selector-col-disponiveis">
            <div class="selector-list-title">Produtos dispon&iacute;veis</div>
            <div class="produto-mobile-cards">
              <div v-if="loading" class="produto-mobile-empty">
                Buscando dados...
              </div>
              <div v-else-if="filteredList.length === 0" class="produto-mobile-empty">
                Nenhum produto encontrado para a pesquisa.
              </div>
              <div
                v-for="item in filteredList"
                :key="'produto_disponivel_' + item.id"
                class="produto-disponivel-card"
              >
                <div class="produto-card-header">
                  <div class="produto-card-title">{{ item.produto }}</div>
                  <div class="produto-card-actions">
                    <v-btn small color="success" outlined @click="addProduto(item)">
                      <v-icon left small>mdi-plus</v-icon>
                      Adicionar
                    </v-btn>
                    <v-btn small color="error" outlined @click="cancelarProduto(item)">
                      <v-icon left small>mdi-close-thick</v-icon>
                      Cancelar
                    </v-btn>
                  </div>
                </div>
                <div class="produto-card-grid">
                  <div>
                    <div class="produto-card-label">ID</div>
                    <div class="produto-card-value">{{ item.idProduto }}</div>
                  </div>
                  <div>
                    <div class="produto-card-label">Item</div>
                    <div class="produto-card-value">{{ item.produto }}</div>
                  </div>
                  <div>
                    <div class="produto-card-label">Quantidade</div>
                    <div class="produto-card-value">{{ item.quantidadeAutorizado }}</div>
                  </div>
                  <div>
                    <div class="produto-card-label">C&oacute;digo</div>
                    <div class="produto-card-value">{{ item.codigo || '-' }}</div>
                  </div>
                  <div>
                    <div class="produto-card-label">Centro de custo</div>
                    <div class="produto-card-value">{{ item.centroCusto }}</div>
                  </div>
                  <div>
                    <div class="produto-card-label">Local</div>
                    <div class="produto-card-value">{{ item.localEntrega }}</div>
                  </div>
                  <div>
                    <div class="produto-card-label">Departamento</div>
                    <div class="produto-card-value">{{ item.departamento }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="produto-table-scroll produto-disponiveis-scroll">
              <v-data-table
                :headers="headers"
                :items="filteredList"
                class="elevation-1 produto-data-table produto-disponiveis-table"
                :loading="loading"
                :mobile-breakpoint="768"
                loading-text="Buscando dados..."
                no-data-text="Não há produtos disponíveis para cotação."
                no-results-text="Nenhum produto encontrado para a pesquisa."
                :search="search"
                :footer-props="{
                  showFirstLastPage: true,
                  itemsPerPageText: 'Items por página',
                  itemsPerPageOptions: [-1],
                }"
              >
                <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click="addProduto(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="green">mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar produto</span>
                </v-tooltip>
              </template>
              <template v-slot:item.excluir="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click="cancelarProduto(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="red">mdi-close-thick</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar Produto da Solicitação</span>
                </v-tooltip>
                </template>
              </v-data-table>
            </div>
          </v-col>

          <v-col cols="12" md="4" class="produto-selector-col produto-selector-col-adicionados">
            <div class="selector-list-title">Produtos adicionados</div>
            <div class="produto-table-scroll">
              <v-data-table
                :headers="headers2"
                :items="produtosL"
                class="elevation-1 produto-data-table"
                :mobile-breakpoint="768"
                no-data-text="Nenhum produto adicionado."
                no-results-text="Nenhum produto encontrado para a pesquisa."
                :footer-props="{
                  showFirstLastPage: true,
                  itemsPerPageText: 'Items por página',
                  itemsPerPageOptions: [-1],
                }"
              >
                <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click="removerProduto(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover produto</span>
                </v-tooltip>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getUserBuyerDepartments } from "@/services/loginService";
import { cancelarItemSolicitacaoAsync } from "../../../services/solicitacaoService";

export default {
  name: "produto",
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    headers: [
      { text: "", value: "actions", sortable: false, width: "36px", class: "col-actions", cellClass: "col-actions" },
      {
        text: "ID",
        align: "start",
        value: "idProduto",
        width: "56px",
        class: "col-id",
        cellClass: "col-id",
      },
      { text: "ITEM", value: "produto", class: "col-produto", cellClass: "col-produto" },
      { text: "QTN", value: "quantidadeAutorizado", width: "52px", class: "col-qtn", cellClass: "col-qtn" },
      { text: "SC", value: "idSolicitacao", width: "52px", class: "col-sc", cellClass: "col-sc" },
      { text: "CC", value: "centroCusto", width: "90px", class: "col-compact-text", cellClass: "col-compact-text" },
      { text: "LOCAL", value: "localEntrega", width: "90px", class: "col-compact-text", cellClass: "col-compact-text" },
      { text: "DPTO", value: "departamento", width: "82px", class: "col-compact-text", cellClass: "col-compact-text" },
      { text: "STATUS", value: "status", width: "78px", class: "col-status", cellClass: "col-status" },
      { text: "", value: "excluir", sortable: false, width: "36px", class: "col-actions", cellClass: "col-actions" },
    ],

    headers2: [
      { text: "", value: "actions", sortable: false, width: "36px", class: "col-actions", cellClass: "col-actions" },
      {
        text: "ID",
        align: "start",
        value: "idProduto",
        width: "54px",
        class: "col-id",
        cellClass: "col-id",
      },
      { text: "ITEM", value: "produto", class: "col-produto", cellClass: "col-produto" },
      { text: "COD.", value: "codigo", width: "70px", class: "col-codigo", cellClass: "col-codigo" },
      { text: "DPTO", value: "departamento", width: "78px", class: "col-compact-text", cellClass: "col-compact-text" },
      { text: "QTN", value: "quantidadeAutorizado", width: "50px", class: "col-qtn", cellClass: "col-qtn" },
    ],
  }),
  props: {
    produtosL: Array,
    showModal: Boolean,
  },
  computed: {
    ...mapState("solicitacao", [
      "produtosSolicitacao",
      "carregandoProdutosCotacao",
    ]),
    produtosAdicionados() {
      return this.produtosL.map((p) => p.idSolicitacaoItem);
    },
    filteredList() {
      var departamentosComprador = getUserBuyerDepartments();
      console.log(departamentosComprador);
      return this.produtosSolicitacao.filter((p) => {
        return (
          (p.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            p.produto.toLowerCase().includes(this.search.toLowerCase()) ||
            p.idSolicitacao.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            p.departamento.toLowerCase().includes(this.search.toLowerCase())) &&
          departamentosComprador.includes(p.idDepartamento) &&
          !this.produtosAdicionados.includes(p.id)
        );
      });
    },
    loading() {
      return this.carregandoProdutosCotacao;
    },
  },
  methods: {
    ...mapActions("solicitacao", ["removeProdutoCotacao"]),
    updateObjectEstate() {
      return this.$refs.form.validate();
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    async cancelarProduto(item) {
      try {
        await this.$confirm(
          "Este item será cancelado definitivamente da solicitação de origem, não haverá mais cotação para o mesmo.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        this.removeProdutoCotacao(item);
        await cancelarItemSolicitacaoAsync(item.id);
      } catch (e) {
        console.log("Cancelado pelo usuário");
      }
    },
    addProduto: function (p) {
      var produto = new Object();
      produto.idSolicitacaoItem = p.id;
      produto.idProduto = p.idProduto;
      produto.idSolicitacao = p.idSolicitacao;
      produto.quantidadeSolicitacao = p.quantidade;
      produto.quantidadeAutorizado = p.quantidadeAutorizado;
      produto.produto = p.produto;
      produto.codigo = p.codigo;
      produto.departamento = p.departamento;
      produto.unidadeAdm = p.unidadeAdm;
      //produto.idLocalEntrega = p.idLocalEntrega;
      //produto.idCentroCusto = p.idCentroCusto;
      produto.centroCusto = p.centroCusto;
      produto.unidadeMedida = p.unidadeMedida;
      produto.index =
        this.produtosL.length === 0
          ? 0
          : this.produtosL[this.produtosL.length - 1].index + 1;

          console.log(produto);
      this.produtosL.push(JSON.parse(JSON.stringify(produto)));
    },
    removerProduto(p) {
      this.produtosL.splice(p, 1);
    },
  },
};
</script>
<style scoped>
.produto-selector-root,
.produto-selector-card {
  width: 100%;
}
.produto-selector-root {
  margin: 0;
}

.produto-selector-grid {
  margin: 0 -6px;
}

.produto-selector-col {
  min-width: 0;
  padding: 6px;
}
.selector-list-title {
  color: #263238;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.3;
  margin: 0 0 8px;
}

.produto-data-table {
  max-width: 100%;
}

.produto-table-scroll {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.produto-table-scroll ::v-deep .v-data-table__wrapper {
  max-height: 420px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.produto-table-scroll ::v-deep table {
  width: 100%;
  table-layout: fixed;
}

.produto-table-scroll ::v-deep thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}

.produto-table-scroll ::v-deep th,
.produto-table-scroll ::v-deep td {
  height: auto;
  padding: 0 4px;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
  vertical-align: middle;
}

.produto-table-scroll ::v-deep th {
  font-size: 0.72rem;
  line-height: 1.2;
}

.produto-table-scroll ::v-deep td {
  font-size: 0.78rem;
  line-height: 1.25;
}

.produto-table-scroll ::v-deep .col-actions {
  padding-left: 0;
  padding-right: 0;
  text-align: center;
}

.produto-table-scroll ::v-deep .col-produto {
  min-width: 160px;
}

.produto-table-scroll ::v-deep .col-id,
.produto-table-scroll ::v-deep .col-qtn,
.produto-table-scroll ::v-deep .col-sc,
.produto-table-scroll ::v-deep .col-codigo,
.produto-table-scroll ::v-deep .col-status {
  word-break: keep-all;
  overflow-wrap: normal;
}

.produto-table-scroll ::v-deep .v-btn--icon.v-size--small {
  height: 28px;
  width: 28px;
}

.produto-table-scroll ::v-deep .v-data-footer {
  padding: 0 4px;
}
.produto-mobile-cards {
  display: none;
}

@media (max-width: 768px) {
  .produto-selector-card {
    box-shadow: none;
  }

  .produto-disponiveis-table {
    display: none;
  }

  .produto-disponiveis-scroll {
    display: none;
  }

  .produto-table-scroll ::v-deep .v-data-table__wrapper {
    max-height: none;
    overflow: hidden;
    border: 0;
  }

  .produto-mobile-cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    margin-bottom: 16px;
  }

  .produto-mobile-empty,
  .produto-disponivel-card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fff;
    padding: 12px;
  }

  .produto-card-header {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 10px;
  }

  .produto-card-title {
    color: #263238;
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .produto-card-actions {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .produto-card-actions .v-btn {
    width: 100%;
    max-width: 100%;
    margin: 0;
    white-space: normal;
  }

  .produto-card-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    width: 100%;
  }

  .produto-card-label {
    color: #607d8b;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  .produto-card-value,
  .produto-mobile-empty {
    color: #263238;
    font-size: 0.9rem;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .produto-selector-card,
  .produto-data-table,
  .produto-data-table ::v-deep .v-data-table__wrapper {
    max-width: 100%;
    overflow-x: hidden;
  }

  .produto-selector-card ::v-deep .v-card__title {
    padding: 8px 0 12px;
  }

  .produto-data-table ::v-deep table,
  .produto-data-table ::v-deep tbody,
  .produto-data-table ::v-deep tr,
  .produto-data-table ::v-deep td {
    max-width: 100%;
  }

  .produto-data-table ::v-deep .v-data-table__mobile-row {
    align-items: flex-start;
    min-height: auto;
    padding: 8px 0;
  }

  .produto-data-table ::v-deep .v-data-table__mobile-row__cell {
    max-width: 100%;
    text-align: right;
    overflow-wrap: anywhere;
    white-space: normal;
  }


  .produto-data-table ::v-deep table {
    width: 100%;
    table-layout: auto;
  }

  .produto-data-table ::v-deep th,
  .produto-data-table ::v-deep td {
    padding: 0;
  }

  .produto-data-table ::v-deep .v-data-table__mobile-row {
    display: grid;
    grid-template-columns: minmax(64px, 28%) minmax(0, 1fr);
    align-items: start;
    column-gap: 10px;
    min-height: auto;
    padding: 8px 10px;
  }

  .produto-data-table ::v-deep .v-data-table__mobile-row__header {
    color: #263238;
    font-size: 0.72rem;
    font-weight: 700;
    line-height: 1.2;
    min-width: 0;
    overflow-wrap: normal;
    text-align: left;
    white-space: nowrap;
    word-break: normal;
  }

  .produto-data-table ::v-deep .v-data-table__mobile-row__cell {
    color: #263238;
    font-size: 0.8rem;
    line-height: 1.25;
    max-width: 100%;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: left;
    white-space: normal;
    word-break: normal;
  }
  .produto-data-table ::v-deep .v-btn {
    margin: 0 4px 4px 0;
  }
}

.subtable-wrapper {
  padding: 8px 0;
  box-sizing: border-box;
}

.styled-subtable {
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 16px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: white;
  overflow: hidden;
}

.styled-subtable th {
  background-color: #f0f0f0;
  font-weight: bold;
  color: #333;
  font-size: 13px;
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ccc;
}

.styled-subtable td {
  font-size: 13px;
  padding: 8px;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
}

.v-icon {
  cursor: pointer;
}
.auto-width {
  white-space: nowrap;
  width: 1%;
}
.flex-fill {
  width: 100%;
}
</style>
